export default __webpack_public_path__ + "static/media/User-Profile.7a2cefcc.svg";